import React, { useState } from 'react';
import {
  CancelButton,
  SaveButton, SpaceBetweenFlex,
} from './styles';
import DocumentName from '../DocumentName';
import { withTranslation } from 'react-i18next';
import { ATTACHMENT_PREVIEW_MODAL } from './translationValues';
import ComplexPreviewModal from './ComplexPreviewModal';
import ComplexDocumentHistoryProvider from '../../context/complexDocumentContext';

const NAMESPACES = ['ATTACHMENT_PREVIEW_MODAL'];

const AttachmentPreviewModal = props => {
  const { visible, onCancel, targetTemplate, onProceed, t } = props;
  const [attachmentName, setAttachmentName] = useState(targetTemplate.name);

  const renderHeader = () => {
    return (
      <SpaceBetweenFlex>
        <DocumentName
          inverted={1}
          disabled={false}
          templateName={attachmentName}
          changeTemplateName={setAttachmentName}
          placeholder={t(
            ATTACHMENT_PREVIEW_MODAL.FILE_NAME_PLACEHOLDER.key,
            ATTACHMENT_PREVIEW_MODAL.FILE_NAME_PLACEHOLDER.value,
          )}
        />
        <SpaceBetweenFlex>
          <CancelButton key="cancel" onClick={onCancel}>
            {t(
              ATTACHMENT_PREVIEW_MODAL.CANCEL_BUTTON.key,
              ATTACHMENT_PREVIEW_MODAL.CANCEL_BUTTON.value,
            )}
          </CancelButton>
          <SaveButton key="submit" disabled={!attachmentName || attachmentName.trim() === ''} onClick={() => onProceed(attachmentName)}>
            {t(
              ATTACHMENT_PREVIEW_MODAL.ADD_ATTACHMENT_BUTTON.key,
              ATTACHMENT_PREVIEW_MODAL.ADD_ATTACHMENT_BUTTON.value,
            )}
          </SaveButton>
        </SpaceBetweenFlex>
      </SpaceBetweenFlex>
    );
  };

  return (
    <ComplexDocumentHistoryProvider>
        <ComplexPreviewModal
          visible={visible}
          onCancel={onCancel}
          type={'document'}
          templateData={targetTemplate}
          attachmentHeader={renderHeader()}
        />
    </ComplexDocumentHistoryProvider>
  );
};

export default withTranslation(NAMESPACES)(AttachmentPreviewModal);
